import axios from "axios";
import React, { Dispatch, SetStateAction } from 'react';
import { AnyIfEmpty } from "react-redux";
import { GET_VENDOR_LOCKER_LIST_FAILURE, GET_VENDOR_LOCKER_LIST_REQUEST, GET_VENDOR_LOCKER_LIST_SUCCESS, RESET_VENDOR_LOCKER_LIST_STATE } from "../constants/vendorLockerList.constants";

export interface VendorLockerListParams {
    locationId: string;
    startDate: string;
    endDate: string;
    startTime: string;
    endTime: string;
    allowEntireTimeBlock: boolean;
    allowStratEndTimeEachDay: boolean;
    vendorId?: string;
}

const getVendorLockerListRequest = () => {
    return {
        type: GET_VENDOR_LOCKER_LIST_REQUEST,
    };
};

const getVendorLockerListSuccess = (lockerData: AnyIfEmpty<object>) => {
    return {
        type: GET_VENDOR_LOCKER_LIST_SUCCESS,
        payload: lockerData,
    };
};

const getVendorLockerListFailure = (lockerError: string) => {
    return {
        type: GET_VENDOR_LOCKER_LIST_FAILURE,
        payload: lockerError,
    };
};

export const resetVendorLockerListState = () => {
    return {
        type: RESET_VENDOR_LOCKER_LIST_STATE,
    };
};

export const getVendorLockerList =
    (params: VendorLockerListParams) =>
        async (dispatch: Dispatch<any>) => {
            dispatch(getVendorLockerListRequest());
            try {
                const response = await axios.get(`/admin/vendor/availableLockers`, { params });
                if (response?.data?.available && response?.data?.lockers) {
                    dispatch(getVendorLockerListSuccess(response.data?.lockers))
                } else {
                    dispatch(getVendorLockerListFailure(response.data.message))
                }
            } catch (error: any) {
                dispatch(getVendorLockerListFailure(error.response?.data?.message || "Something went wrong"));
            }
        };
